import { RetailerApiClient } from '@/services/RetailerApiClient.js'

export default {
  getUsers(query) {
    return RetailerApiClient.get('retailer-users', {
      params: query
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getUser(id) {
    return RetailerApiClient.get('retailer-users/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  editUser(id, payload) {
    return RetailerApiClient.patch('retailer-users/' + id, payload)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  editPassword(id, password) {
    return RetailerApiClient.patch('retailer-users/' + id, password)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createUser(user) {
    return RetailerApiClient.post('retailer-users', user)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deleteUser(id) {
    return RetailerApiClient.delete('retailer-users/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getNotifications(id) {
    return RetailerApiClient.get('retailer-users/' + id + '/notifications')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  filterNotificationsBySeverities(userId) {
    return RetailerApiClient.get('retailer-users/' + userId + '/filter-notifications-by-severity')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  markAsReadNotification(userId, id) {
    return RetailerApiClient.patch('retailer-users/' + userId + '/notifications/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  validatePassword(password) {
    return RetailerApiClient.post('auth/password/validate', {
      password: password
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  markAsReadNotifications(userId) {
    return RetailerApiClient.patch('retailer-users/' + userId + '/notifications')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  markAsSeenNotifications(userId) {
    return RetailerApiClient.patch('retailer-users/' + userId + '/notifications/seen')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
